import { render, staticRenderFns } from "./BlogReviewsTab.vue?vue&type=template&id=4c559f48"
import script from "./BlogReviewsTab.vue?vue&type=script&lang=js"
export * from "./BlogReviewsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports